import React from 'react'
import { Controller } from 'react-hook-form'

import { RadioInputDecoupled } from './RadioInputDecoupled'

import { FormLabel } from '../FormLabel'

import type { RadioInputProps } from './types'

/**
 * Form Radio component
 * @component
 * @param {string} name - form key name
 * @param {string} options - array of options objects {value: 'value', label: 'label'}
 * @param {string} label - text label above tabs
 * @example
 * import { useForm } from 'react-hook-form'
 *
 * const { control } = useForm()
 * const options = [
 *    { label: 'LabelOne', value: 'one' },
 *    { label: 'LabelTwo', value: 'two' },
 * ]
 *
 * return (
 *  <RadioInput
 *    name="radio"
 *    label="Radio label"
 *    control={control}
 *    options={options}
 *  />
 * )
 */

export const RadioInput = <T extends unknown>({
  control,
  label,
  name,
  ...restProps
}: RadioInputProps<T>) => (
  <Controller
    control={control}
    name={name}
    render={({ field }) => (
      <RadioInputDecoupled
        formLabel={label && <FormLabel>{label}</FormLabel>}
        {...restProps}
        {...field}
      />
    )}
  />
)

RadioInput.displayName = 'RadioInput'

export { RadioInputDecoupled } from './RadioInputDecoupled'
